var _path, _line, _circle, _circle2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntrnautsIoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 140,
    viewBox: "0 0 420 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 90        C60 90 40 70 40 50        C40 30 60 20 75 25        C85 10 110 10 120 25        C140 20 160 30 160 50        C160 70 140 90 110 90        Z",
    fill: "#0E2A47"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 60,
    x2: 120,
    y2: 45,
    stroke: "#BFC7CF",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 60,
    r: 6,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 45,
    r: 6,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 72,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 36,
    fill: "#0E2A47"
  }, "\n    intrnauts.io\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrnautsIoLogo);
export default __webpack_public_path__ + "static/media/intrnauts-io-logo.091a9f58e8be57deb62b3db4624adf29.svg";
export { ForwardRef as ReactComponent };